export default __webpack_public_path__ + "static/media/Chandan Kar, Member, NIB Alumni Association.18dd1818.jpg";